import React from 'react';
import PublicLayout from '../PublicLayout';
import { Target, Eye, Heart, Star, Users, Lightbulb, Globe, Shield, Award, Volume2, Calendar, School, TrendingUp, Handshake } from 'lucide-react';

const MissionVision = () => {
  const objectives = [
    {
      title: 'Advocacy',
      description: 'Be a strong advocate for respiratory therapists, working towards recognition, licensure, and regulation in all African nations.',
      icon: Award
    },
    {
      title: 'Public Awareness',
      description: 'Raise awareness about respiratory health issues and the role of respiratory therapists through public campaigns and community outreach.',
      icon: Volume2
    },
    {
      title: 'Annual Conferences',
      description: 'Organize annual conferences featuring world-class speakers, workshops, and cutting-edge research in respiratory care.',
      icon: Calendar
    },
    {
      title: 'Student Exchange Programs',
      description: 'Facilitate student exchange programs, allowing respiratory therapy students to gain international experience and perspectives.',
      icon: School
    },
    {
      title: 'Promote Excellence',
      description: 'ARCA is committed to advancing the standards of respiratory care in Africa through education, research, and best practices.',
      icon: Star
    },
    {
      title: 'Professional Development',
      description: 'Offer continuous learning opportunities, scholarships, and mentorship programs for respiratory therapists and students.',
      icon: TrendingUp
    },
    {
      title: 'Collaboration',
      description: 'Foster connections with respiratory care associations worldwide to exchange knowledge and expertise, facilitating global partnerships. Collaborate with healthcare professionals to advance the practice of respiratory therapy in Africa.',
      icon: Handshake
    }
  ];

  return (
    <PublicLayout>
      <div className="py-5">
        <div className="container">
          {/* Header */}
          <div className="row justify-content-center text-center mb-5">
            <div className="col-lg-8">
              <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                   style={{ width: '80px', height: '80px', backgroundColor: '#6B8E23' }}>
                <Target className="text-white" size={40} />
              </div>
              <h1 className="display-4 fw-bold text-dark mb-3">Mission, Vision & Objectives</h1>
              <p className="lead text-muted">The guiding principles that drive our work</p>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-10">
            {/* Mission */}
            <div className="card shadow border-0 mb-4">
              <div className="card-body p-4 p-lg-5">
              <div className="d-flex align-items-center mb-4">
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle me-3" 
                     style={{ width: '80px', height: '80px', backgroundColor: '#e8f5e9' }}>
                  <Target style={{ color: '#6B8E23' }} size={40} />
                </div>
                <div>
                  <h2 className="h3 fw-bold text-dark mb-1">Our Mission</h2>
                  <p className="text-muted mb-0">What we do and why we exist</p>
                </div>
              </div>
              <p className="h5 text-muted fst-italic border-start border-4 ps-4 mb-0" style={{ borderColor: '#6B8E23 !important' }}>
                To reduce the burden of respiratory diseases in Africa by strengthening the respiratory workforce, providing opportunities for professional growth, and promoting innovative solutions to improve respiratory care.
              </p>
              </div>
            </div>

            {/* Vision - Made more prominent */}
            <div className="card shadow border-0 mb-4" style={{ background: 'linear-gradient(135deg, #6B8E23 0%, #556B1F 100%)' }}>
              <div className="card-body p-4 p-lg-5 text-white">
              <div className="d-flex align-items-center mb-4">
                <div className="d-inline-flex align-items-center justify-content-center rounded-circle me-3" 
                     style={{ width: '80px', height: '80px', backgroundColor: 'rgba(255, 255, 255, 0.2)' }}>
                  <Eye className="text-white" size={40} />
                </div>
                <div>
                  <h2 className="h3 fw-bold mb-1">Our Vision</h2>
                  <p className="mb-0 opacity-75">The future we're working toward</p>
                </div>
              </div>
              <div className="bg-white bg-opacity-10 rounded p-4">
                <p className="h5 fst-italic mb-0">
                  The Africa Respiratory Care Association (ARCA) is dedicated to uniting Respiratory Therapists across the African continent and welcoming external members to foster excellence in respiratory therapy, care, practice, and education. ARCA aims to provide opportunities for professional growth, knowledge exchange, and international networking to elevate respiratory care in Africa.
                </p>
              </div>
              </div>
            </div>

            {/* Our Objectives */}
            <div className="mb-4">
              <h2 className="h3 fw-bold text-dark mb-4 text-center">Our Objectives</h2>
              <div className="row g-4">
                {objectives.map((objective, index) => (
                  <div key={index} className="col-md-6 col-lg-4">
                    <div className="card shadow-sm border-0 h-100">
                      <div className="card-body p-4">
                      <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3" 
                           style={{ width: '64px', height: '64px', backgroundColor: '#e8f5e9' }}>
                        {React.createElement(objective.icon, { style: { color: '#6B8E23' }, size: 32 })}
                      </div>
                      <h3 className="h5 fw-bold text-dark mb-2">{objective.title}</h3>
                      <p className="text-muted mb-0">{objective.description}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default MissionVision;